<template>
  <dialog
    ref="dialog"
    class="dnl:backdrop:fixed dnl:backdrop:z-1000 dnl:z-1001 dnl:backdrop:h-full dnl:backdrop:w-full dnl:shadow-md dnl:border-none dnl:absolute dnl:py-6 dnl:px-2.5 dnl:top-1/2 dnl:left-1/2 dnl:translate-y-[-50%] dnl:translate-x-[-50%] dnl:max-w-sm dnl:rounded-lg dnl:bg-white dnl:text-base dnl:shadow-2xl"
    :open="visible"
    @click="checkClickOutside"
  >
    <slot name="header"></slot>

    <slot name="content"></slot>

    <div
      v-if="actions"
      class="dnl:flex dnl:justify-center dnl:items-center dnl:pt-6"
      method="dialog"
    >
      <button
        class="dnl:bg-jeans-indigo dnl:text-white dnl:rounded-full dnl:py-1 dnl:px-5 dnl:mr-2 dnl:font-bold"
        @click="confirm"
      >
        {{ $t(confirmBtnText) }}
      </button>

      <button
        class="dnl:bg-blue-600 dnl:border-none dnl:text-white dnl:rounded-full dnl:py-1 dnl:px-5 dnl:font-bold dnl:mr-2.5"
        type="submit"
        autofocus
        @click="cancel"
      >
        {{ $t(cancelBtnText) }}
      </button>
    </div>
  </dialog>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  const dialog = ref<HTMLDialogElement>();

  const props = defineProps({
    visible: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Boolean,
      default: true,
    },
    closeOnClickOutside: {
      type: Boolean,
      default: false,
    },
    confirmBtnText: {
      type: String,
      default: 'generic.confirm',
    },
    cancelBtnText: {
      type: String,
      default: 'generic.cancel',
    },
  });

  const emit = defineEmits(['confirm', 'cancel']);

  const isVisible = ref(props.visible);

  const showModal = () => {
    dialog.value?.showModal();
    isVisible.value = true;
  };

  const cancel = () => {
    emit('cancel');
    dialog.value?.close();
  };

  const confirm = () => {
    emit('confirm');
    dialog.value?.close();
  };

  const checkClickOutside = (event: MouseEvent) => {
    if (props.closeOnClickOutside && event.target === event.currentTarget) {
      cancel();
    }
  };

  defineExpose({
    show: showModal,
    close: (returnVal?: string): void => dialog.value?.close(returnVal),
    visible: isVisible.value,
  });
</script>

<style scoped>
  dialog:not([open]) {
    display: none;
  }
</style>
